import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="news-read" — the what's-new modal contents. Opening the modal
// marks the news read server-side (WhatsnewsController#index), but the topbar renders before
// that, so the unread indicator would linger until the next full navigation. On connect, fade
// out the new-UI bell dot (.js-news-dot) and recolor the classic bell (#bell i).
export default class extends Controller {
  connect() {
    document.querySelectorAll(".js-news-dot").forEach(dot => {
      dot.classList.add("opacity-0", "scale-0")
      setTimeout(() => dot.remove(), 300)
    })
    const bell = document.querySelector("#bell i")
    if (bell) {
      bell.style.transition = "color 0.3s"
      bell.style.color = "#6c757d"
    }
  }
}
